export class Version { public version = '22.1111.1231'; } 
